const SIZE = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-12 w-12",
};

const Spinner = ({ size = "md", className = "" }) => (
  <div
    className={`animate-spin rounded-full border-b-2 border-brand-ink ${SIZE[size]} ${className}`}
  />
);

export default Spinner;
